export default "__VITE_ASSET__CUFHY0Ns__"